<template>
  <div
    class="items-center hidden py-5 space-x-1 text-xs font-light text-gray-700 md:flex"
  >
    <a href="/find-broker" class="flex">
      <ArrowLeftSvg color="primary" height="4" width="4" />
      <span class="ml-1 text-primary">Back to search</span>
    </a>
    <p class="px-1 text-gray-300">|</p>

    <home-svg color="primary" height="3" width="3" />
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <a href="/find-broker#agents" class="text-primary">Find Agent</a>
    <p class="text-primary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <a
      :href="
        $router.resolve({
          name: 'CompanyView',
          params: {
            id: agent.company.id,
            slug: agent.company ? $sanitizeTitle(agent.company.name) : '',
          },
        }).href
      "
      class="text-primary"
      >{{ agent.company.name }}</a
    >

    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <p class="">{{ agent.name }}</p>
  </div>
</template>
<script>
import ArrowLeftSvg from "@/components/svg/ArrowLeftSvg";
import HomeSvg from "@/components/svg/HomeSvg.vue";
export default {
  components: {
    ArrowLeftSvg,
    HomeSvg,
  },
  props: {
    agent: Object,
  },
};
</script>
